import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRinging = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.49 19.75L18.8 20.44C18.42 20.79 17.94 20.98 17.42 21C16.03 20.95 13.11 20.16 8.48001 15.52C3.85001 10.89 3.04 7.93998 3 6.60998C3.02 6.09998 3.21 5.60997 3.56 5.22997L4.25 4.53997L5.20001 3.59002C5.39001 3.39002 5.62 3.24001 5.87 3.14001C6.14 3.04001 6.41 3.01002 6.69 3.03002C6.96 3.05002 7.21999 3.14002 7.45999 3.28002C7.69999 3.42002 7.89999 3.61002 8.04999 3.84002L9.39999 5.72997C9.52999 5.94997 9.61 6.19 9.63 6.45C9.65 6.7 9.6 6.95999 9.5 7.18999L8.60001 8.90002C8.54001 9.03002 8.51001 9.18001 8.51001 9.33001C8.51001 9.48001 8.54001 9.62 8.60001 9.76C9.19001 10.97 10.01 12.06 11.02 12.95C11.92 13.95 13 14.77 14.22 15.37C14.35 15.43 14.49 15.46 14.65 15.46C14.81 15.46 14.94 15.43 15.08 15.37L16.8 14.48C17.04 14.37 17.29 14.33 17.55 14.34C17.81 14.36 18.05 14.44 18.27 14.57L20.17 15.91C20.4 16.06 20.6 16.26 20.74 16.5C20.87 16.74 20.97 17 20.99 17.27C21.02 17.54 20.99 17.82 20.89 18.08C20.79 18.34 20.63 18.57 20.43 18.76L19.52 19.75H19.49Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9902 3C14.9102 3 15.8202 3.18003 16.6802 3.53003C17.5302 3.88003 18.3002 4.39999 18.9602 5.04999C19.6102 5.69999 20.1303 6.47001 20.4803 7.32001C20.8303 8.17001 21.0103 9.08 21.0103 10",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9902 7C14.3902 7 14.7803 7.07998 15.1403 7.22998C15.5103 7.37998 15.8402 7.6 16.1202 7.88C16.4002 8.16 16.6202 8.48999 16.7702 8.85999C16.9202 9.21999 17.0002 9.62001 17.0002 10.01",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgRinging;
